import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material';


const PARAMETER_NAME_OPTIONS = ['Custom Export Path'];

const AddNewParameterModal = ({
  open, onClose, onSave, partners = [], accounts = [],
}) => {
  const [selectedPartnerId, setSelectedPartnerId] = useState('');
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState('');
  const [paramName, setParamName] = useState('');
  const [paramValue, setParamValue] = useState('');

  useEffect(() => {
    if (selectedPartnerId) {
      const matchingAccounts = accounts.filter(acc => acc.partnerId === selectedPartnerId);
      setFilteredAccounts(matchingAccounts);
    }
    else {
      setFilteredAccounts([]);
    }
    setSelectedAccountId('');
  }, [selectedPartnerId, accounts]);

  const handleSave = () => {
    if (selectedPartnerId && selectedAccountId && paramName && paramValue) {
      onSave({
        partnerId: selectedPartnerId,
        accountId: selectedAccountId,
        name: paramName,
        value: paramValue,
      });
    }
  };

  const handleClose = () => {
    setSelectedPartnerId('');
    setSelectedAccountId('');
    setParamName('');
    setParamValue('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth='sm'>
      <DialogTitle>Add New Export Parameter</DialogTitle>
      <DialogContent>
        <Box display='flex' flexDirection='column' gap={2} mt={1}>
          <TextField
            select
            label='Export Type'
            fullWidth
            value={selectedPartnerId}
            onChange={(e) => setSelectedPartnerId(e.target.value)}
          >
            {partners.map((partner) => (
              <MenuItem key={partner.id} value={partner.id}>
                {partner.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label='Destination Account Name'
            fullWidth
            value={selectedAccountId}
            onChange={(e) => setSelectedAccountId(e.target.value)}
            disabled={!selectedPartnerId}
          >
            {filteredAccounts.map((account) => (
              <MenuItem key={account.id} value={account.id}>
                {account.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label='Parameter Name'
            fullWidth
            value={paramName}
            onChange={(e) => setParamName(e.target.value)}
          >
            {PARAMETER_NAME_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label='Parameter Value'
            fullWidth
            value={paramValue}
            onChange={(e) => setParamValue(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant='outlined'>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant='contained'
          color='primary'
          disabled={
            !selectedPartnerId || !selectedAccountId || !paramName || !paramValue
          }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNewParameterModal;
